/**
 * The wire format between the browser beacon and `/api/beacon`. Shared by
 * the client component and the handler, so it must stay free of server-only
 * imports.
 */
import { z } from "zod";

export const BEACON_ENDPOINT = "/api/beacon";

export const BEACON_PATH_MAX_LENGTH = 512;
export const BEACON_REFERRER_MAX_LENGTH = 2048;

/**
 * Unknown keys are stripped, so a client cannot smuggle in a visitor id, a
 * user agent or a timestamp: everything about the visitor is decided on the
 * server from the request itself.
 */
export const beaconPayloadSchema = z.object({
  /**
   * Site-relative path, query string included so campaign parameters
   * survive. The full URL is rebuilt server-side against the canonical
   * origin, so a payload can never file a view under another host.
   */
  path: z.string().max(BEACON_PATH_MAX_LENGTH).startsWith("/"),
  /** `document.referrer` on the first view of a visit; empty afterwards. */
  referrer: z.string().max(BEACON_REFERRER_MAX_LENGTH),
  locale: z.enum(["sv", "en"]).optional(),
});

export type BeaconPayload = z.infer<typeof beaconPayloadSchema>;
